import styled from 'styled-components'

export const ModalContainer = styled.div`
  padding: 24px;
  min-width: 400px;
`

export const InstructionText = styled.p`
  margin: 0 0 20px 0;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-left: 4px solid #007bff;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.4;
  color: #495057;
`

export const FieldContainer = styled.div`
  margin-bottom: 24px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`

export const CancelButton = styled.button`
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #5a6268;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.3);
  }
`

interface ConfirmButtonProps {
  disabled?: boolean
}

export const ConfirmButton = styled.button<ConfirmButtonProps>`
  background-color: ${(props) => (props.disabled ? '#6c757d' : '#007bff')};
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.disabled ? '#6c757d' : '#0056b3')};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.3);
  }
`
